/**
 * /account/:id — de oude losse klantpagina uit het Sales-dashboard (opgeruimd
 * 26 sep 2026). Oude bladwijzers landen op de accountpagina, tab Cijfers.
 * Het id is in beide gevallen het Airtable-record-id van het account, dus er
 * valt niets te vertalen.
 */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export default function OudeAccountDoorverwijzing() {
  const { accountId } = useParams();
  return <Navigate to={`/accounts/${encodeURIComponent(accountId)}/workspace?tab=cijfers`} replace />;
}
